import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-528f719c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrap"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_3 = { class: "inner" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = {
  key: 0,
  class: "footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t_button = _resolveComponent("t-button")!
  const _component_t_icon = _resolveComponent("t-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.getContent)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getContent, (item, index) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: index,
                      class: "description"
                    }, _toDisplayString(item), 1))
                  }), 128))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "content", {}, undefined, true)
            ]),
            (_ctx.footer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_t_button, {
                    text: _ctx.confirmText,
                    onClick: _ctx.onTapByClose,
                    theme: "primary",
                    size: "small"
                  }, null, 8, ["text", "onClick"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onTapByClose && _ctx.onTapByClose(...args)))
            }, [
              _createVNode(_component_t_icon, {
                theme: "highlight",
                "icon-name": "close-circle-outline"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}